import send from '../../utils/fetch'
import {search, nameToSlug} from "../../utils/utils";

const state = {
    campaigns: []
}

const actions = {
    async GET_CAMPAIGNS_TR({commit}) {
        try {
            const {data} = await send('/campaigns', 'GET')
            return data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async GET_TRACKERS({commit}, hash) {
        try {
            const {data} = await send(`/user/tracker?hash=${hash}`, 'GET')
            return data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async GET_CAMPAIGNS({commit, dispatch, getters}) {
        try {
            // await dispatch('GET_ALL_LANDINGS', false)
            // await dispatch('COMPAIGN_OFFERS')
            // await dispatch('GET_TEAM_DOMAINS')

            let {data} = await send('/campaigns', 'GET')
             // data.result = data.result.map(result => {
            //     const get = getters.landings.filter(landing => {
            //         if (landing.id === result.landing_id) {
            //             return landing
            //         }
            //     })[0]

            //     return Object.assign(result, {landing: get, t_id: result.user.team_id, language: get.language})
            // })

            // data.result = data.result.map(campaign => {
            //     const domain = getters.domains.find(domain => domain.id === campaign.domain_id)
            //     return Object.assign(campaign, {domain})
            // })

            // data.result = data.result.map(campaign => {
            //     const offer = getters.offers.find(offer => offer.id === campaign.landing.offer_id)
            //     return Object.assign(campaign, {offer, offer_id: offer.id})
            // })
            commit('SET_CAMPAIGNS', data.result)
            return data.result
        } catch (e) {

        }
    },

    async CREATE_CAMPAIGN({dispatch}, bundle) {
        try {
            const {data} = await send('/campaigns/create', 'POST', {data: bundle})
            dispatch('GET_CAMPAIGNS')
            return data.result
        } catch (e) {
        }
    },

    async UPDATE_CAMPAIGN_STATUS({dispatch}, {id}) {
        try {
            const {data} = await send('/campaigns/destroy', 'DELETE', {data: {id}})
            dispatch('GET_CAMPAIGNS')
            return data
        } catch (e) {
        }
    },

    async UPDATE_CAMPAIGN_NAME({dispatch}, bundle) {
        try {
            const {data} = await send('/campaigns/update', 'PUT', {data: bundle})
            dispatch('GET_CAMPAIGNS')
            return data
        } catch (e) {
        }
    },

    async UPDATE_CAMPAIGN_APPROVE({dispatch}, {id}) {
        try {
            const {data} = await send('/campaigns/approve', 'PUT', {data: {id}})
            dispatch('GET_CAMPAIGNS')
            return data
        } catch (e) {
        }
    }
}

const mutations = {
    SET_CAMPAIGNS(state, data) {
        state.campaigns = data
    }
}

const getters = {
    campaigns: state => state.campaigns,
    filterCampaign: (state, getters) => {
        return (filter) => {
            for (const key in filter) {
                if (filter[key] === null) {
                    delete filter[key]
                }
            }
            return search(state.campaigns.campains, filter)
        }
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}
